import request from '@/utils/request'


// 查询入驻时长列表
export function listEntry(query) {
  return request({
    url: '/merchant/entry/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询入驻时长分页
export function pageEntry(query) {
  return request({
    url: '/merchant/entry/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询入驻时长详细
export function getEntry(data) {
  return request({
    url: '/merchant/entry/detail',
    method: 'get',
    params: data
  })
}

// 新增入驻时长
export function addEntry(data) {
  return request({
    url: '/merchant/entry/add',
    method: 'post',
    data: data
  })
}

// 修改入驻时长
export function updateEntry(data) {
  return request({
    url: '/merchant/entry/edit',
    method: 'post',
    data: data
  })
}

// 删除入驻时长
export function delEntry(data) {
  return request({
    url: '/merchant/entry/delete',
    method: 'post',
    data: data
  })
}
